import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { PopupComponent } from '../../utils/helpers/table/tableHelper';

function ModalComponent(props: any) {
  const [tagName] = useState(props.tagName);
  const [node, setNode] = useState<HTMLElement | undefined>(undefined);

  useEffect(() => {
    const node2 = document.createElement(tagName);
    node2.style.backgroundColor = 'blue';
    document.body.appendChild(node2);

    setNode(node2);

    return () => {
      if (node2 && node2.parentNode) {
        node2.parentNode.removeChild(node2);
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return node
    ? ReactDOM.createPortal(
        <PopupComponent
          tagName={tagName}
          content={props.content}
          module={props.module}
          style={{
            position: 'relative',
            width: '70%',
            margin: '0 auto',
            height: 'auto',
            maxHeight: '70vh',
            marginTop: 'calc(100vh - 85vh - 20px)',
            background: '#fff',
            borderRadius: '14px',
            padding: '10px',
            border: '1px solid #999',
            overflow: 'auto',
          }}
          setOpenModal={props.setOpenModal}
        />,
        node
      )
    : null;
}

export default ModalComponent;
